var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-home",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24.191,
    viewBox: "0 0 24 24.191",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15240",
    "data-name": "Grupo 15240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14504",
    "data-name": "Caminho 14504",
    d: "M26.784,15.9a1.2,1.2,0,0,0-1.567,0l-8.4,7.245a1.2,1.2,0,0,0-.416.909V33.8A1.2,1.2,0,0,0,17.6,35h1.323a1.2,1.2,0,0,1,0,2.4H17.6A3.6,3.6,0,0,1,14,33.8V24.05a3.6,3.6,0,0,1,1.249-2.726l8.4-7.245a3.6,3.6,0,0,1,4.7,0l8.4,7.245A3.6,3.6,0,0,1,38,24.05V33.8a3.6,3.6,0,0,1-3.6,3.6H32.847a1.2,1.2,0,0,1,0-2.4H34.4a1.2,1.2,0,0,0,1.2-1.2V24.05a1.2,1.2,0,0,0-.416-.909Z",
    transform: "translate(-14 -13.205)",
    fill: "#a6abaf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14505",
    "data-name": "Caminho 14505",
    d: "M50.96,72.08v-5.4a2.28,2.28,0,1,0-4.56,0v5.4ZM48.68,62A4.68,4.68,0,0,0,44,66.68v6.6a1.2,1.2,0,0,0,1.2,1.2h6.96a1.2,1.2,0,0,0,1.2-1.2v-6.6A4.68,4.68,0,0,0,48.68,62Z",
    transform: "translate(-36.8 -50.289)",
    fill: "#a6abaf",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHome);
export default __webpack_public_path__ + "static/media/ic-home.a3772ff0f93811a8f0a636e81639f521.svg";
export { ForwardRef as ReactComponent };